//src/components/forDermatologistsSolutionsData.js
import ReachPatients from '../assets/attract_more_patient.jpg';
import ConnectPatients from '../assets/Enhance_your_patient_experience.jpg';
import GetPaid from '../assets/get_paid_faster.jpg';
import CompleteDataControl from '../assets/Manage_records_digitally.jpg';
import DermatologistsImplementation from '../assets/automate_your_practice.jpg';

const forDermatologistsSolutionsData = [
    {
        id: 1,
        title: "Reach new patients",
        text: (
            <>
                47% of patients saw a skincare specialist in the past 12 months.<br />
                Make it easy for them to find your independent mental health practice with:
                <ul>
                    <li>Search engine optimization and marketing</li>
                    <li>Automated reputation management</li>
                    <li>Responsive websites designed to attract patients and drive appointments</li>
                </ul>
            </>
        ),
        image: ReachPatients,
        buttonLabel: "Learn more",
    },
    {
        id: 2,
        title: "Connect with patients",
        text: "Quality care is essential, yet today's clients seek added convenience. Almost 80% would consider changing doctors for a more convenient experience. Doclivo streamlines back-end processes, ensuring front-end convenience without requiring additional effort from you.",
        image: ConnectPatients,
        buttonLabel: "Learn more",
    },
    {
        id: 3,
        title: "Get paid",
        text: (
            <>
                Simplify the billing process for patients and enhance your profitability with Doclivo's billing and payments features:
                <ul>
                    <li>Intuitive practice management</li>
                    <li>Time-saving automation</li>
                    <li>Improved revenue cycle management</li>
                </ul>
            </>
        ),
        image: GetPaid,
        buttonLabel: "Learn more",
    },
    {
        id: 4,
        title: "Complete data control",
        text: "Good decisions rely on good data. Doclivo provides comprehensive data and insights across all aspects of your practice, encompassing growth and revenue.",
        image: CompleteDataControl,
        buttonLabel: "Learn more",
    },
    {
        id: 5,
        title: "Effortless Implementation",
        text: "Switch seamlessly without disrupting your practice. Doclivo ensures an easy start with no requirement for IT expertise or complex processes. Our onboarding, training, and continuous support will guide you every step of the way, ensuring your Consultant Physicians  practice continues without missing a beat.",
        image: DermatologistsImplementation,
        buttonLabel: "Learn more",
    },

    // Add more items as needed

];

export default forDermatologistsSolutionsData;